import { Box } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ScrollableTabs, WsColors, WsTitleBanner } from 'wisestep-base';

import { LayoutTheme } from '../listing/components/Consultants/ConsultantsListingPage';

import UploadBulk from './components/bulkImport/UploadBulk';
import AddConsultantForm from './components/singleImport/AddConsultantForm';

const UploadPage = () => {
  const methods = useForm();
  const navigate = useNavigate();
  const [tabPanelPage, setTabPanelPage] = useState(<UploadBulk />);
  const handleTabClick = (tabId: number) => {
    switch (tabId) {
      case 0:
        setTabPanelPage(<UploadBulk />);
        break;

      case 1:
        setTabPanelPage(<AddConsultantForm />);
        break;
    }
  };
  return (
    <FormProvider {...methods}>
      <LayoutTheme>
        <Box width="100%" height="100%">
          <WsTitleBanner title="Import Consultants" goBack={() => navigate('/consultant')} />
          <Box sx={{ backgroundColor: WsColors.White }} p={2} height="100%">
            <ScrollableTabs
              scrollList={[{ tabName: 'Upload a File' }, { tabName: 'Add a Consultant' }]}
              getTabIndex={(index: number) => handleTabClick(index)}
            />
            <br></br>
            <Box>{tabPanelPage}</Box>
          </Box>
        </Box>
      </LayoutTheme>
    </FormProvider>
  );
};

export default UploadPage;
